import { Capitalize } from 'src/utils/capitalize';

const getCurrentLanguage = () =>
    localStorage.getItem('language') ||
    localStorage.getItem('i18nextLng') ||
    'es';

const getDateLocale = (language?: string) => {
    const code = language?.split('-')[0]?.toLowerCase();

    if (code === 'en') return 'en-US';
    if (code === 'es') return 'es-MX';

    return language || 'es-MX';
};

export const formatDateLabel = (
    date: Date,
    t: (key: string) => string
) => {
    const locale = getDateLocale(getCurrentLanguage());
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (a: Date, b: Date) =>
        a.toDateString() === b.toDateString();

    if (isSameDay(date, today)) return t('Chat.DateToday');
    if (isSameDay(date, yesterday)) return t('Chat.DateYesterday');

    const diff = today.getTime() - date.getTime();
    const days = diff / (1000 * 60 * 60 * 24);

    if (days < 7) {
        return Capitalize(
            date.toLocaleDateString(locale, { weekday: 'long' })
        );
    }

    return date.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
    });
};
